import { Affix, Button, Card, Form, Space } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ImportCnfBillForm from "./ImportCnfBillForm";

export default function AddImportCnfBill(props) {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : width ? `${width}px` : "100%"}` }}
        >
          <Header
            title="Add Import C&F Bill"
            subTitle=""
            addLink="/"
            addText=""
            actions={
              <Space>
                <Button
                  danger
                  size="small"
                  onClick={() =>
                    navigate(
                      "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill",
                    )
                  }
                >
                  Discard
                </Button>
                <Button
                  type="primary"
                  size="small"
                  loading={submitting}
                  disabled={submitting}
                  onClick={() => form.submit()}
                >
                  Submit Request
                </Button>
              </Space>
            }
          />
        </Card>
      </Affix>
      <ImportCnfBillForm
        form={form}
        isEdit={false}
        onSubmittingChange={setSubmitting}
      />
    </>
  );
}
